import { NgModule } from '@angular/core';
import { ExpepharmaSplashScreenService } from '@expepharma/services/splash-screen/splash-screen.service';

@NgModule({
    providers: [ExpepharmaSplashScreenService],
})
export class ExpepharmaSplashScreenModule {
    /**
     * Constructor
     */
    constructor(
        private _expepharmaSplashScreenService: ExpepharmaSplashScreenService
    ) {}
}
